<template>
<div id="g-page" >
  
  <table border="0" id="main-table-screen" >
    <tr>
      <td id="main-table-row1" colspan="3"> 
      </td>
    </tr>

    <tr>
      <td style="width:5%"></td>
      <td id="main-table-row2-dialog-container-td">
        <table border="0" style="width:100%" class="dialog-table-radius">
          <tr>
            <td id="dialog-consent" align="center" >
              <table border="0">
                <td id="dialog-consent-title">
                  <!--Member Consent-->
                  {{ $t("consent.title") }}
                </td>
              </table>
            </td>            
          </tr>
          <tr>
            <td id="dialog-instructions">
              <!--Instructions: Please read each of the following statements carefully. To consent you must check the "I Consent" check box for each individual consent item and then type in your initials. -->
              {{ $t("consent.instructions") }}
            </td>
          </tr>
          <tr>
            <td class="dialog-section">
              <div v-for="item in consents" :key="item.consentTemplateItemId">
                <table style="width:100%;" border="0">
                  <tr>
                    <td class="dialog-section-title">
                      <div style="height:15px" />
                      {{ item.title }}
                      <div style="height:15px" />
                    </td>
                  </tr>
                  <tr>
                    <td class="dialog-section-data"> {{ item.statement }}
                      <div style="height:15px" />
                    </td>
                  </tr>
                  <tr>
                    <td class="dialog-section-commands border-dots">
                      <label :for="'chkConsent' + item.consentTemplateItemId">
                        <!--I consent-->{{ $t("consent.iConsent") }}</label>&nbsp;
                      <input type="checkbox" 
                      :name="'chkConsent' + item.consentTemplateItemId"
                      v-model="consents[getIndex(consents, item.consentTemplateItemId)].consentGiven">

                      &nbsp;&nbsp;-&nbsp;&nbsp;
                      <label :for="'txtInitials' + item.consentTemplateItemId">
                        <!--My inititals-->{{ $t("consent.myInitials") }}</label>&nbsp;
                      <input type="text" 
                            style="width:35px" 
                            ref="refInitials1" 
                            :name="'txtInitials' + item.consentTemplateItemId" 
                            maxlength="3" 
                            v-mask="'AAA'"
                            :disabled="!consents[getIndex(consents, item.consentTemplateItemId)].consentGiven"
                            v-model="consents[getIndex(consents, item.consentTemplateItemId)].consentInitials"
                            />
                      <div style="height:15px" />
                    </td>
                  </tr>
                </table>
              </div>
            </td> 
          </tr>
          <tr>
            <td id="dialog-section-signature-disclaimer">
              <!--By selecting the "I consent" checkbox(s), entering your initials and entering your full name, you are signing this Agreement electronically. You agree that your electronic signature is the legal equivalent of your manual signature on this Agreement. By selecting "I consent" you legally authorize eHealth Engagement, LLC. according to the terms and conditions set forth in this Member Consent statement. You further agree that your use of a key pad, mouse or other device to select an item, button, icon or similar act/action constitutes your signature (hereafter referred to as "E-Signature"), and that acceptance and agreement of the terms specified herein are as if actually signed by you in writing. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature.-->
              {{ $t("consent.disclaimer") }}
            </td>
          </tr>
          <tr>
            <td id="dialog-section-signature">
              <br>
               &nbsp;
              <label for="">
                <!--Sign/Type your Full Name here:-->
                {{ $t("consent.sign") }}</label>&nbsp;
              <input type="text" style="width:150px" 
                            name="txtDigitalSignature"
                            maxlength="82"
                            v-model="digitalSignature" />
                      
            </td>
          </tr>

          <tr>
            <td class="dialog-input-field-buttons">  
              <input type="button" class="dialog-input" v-on:click="goBack" v-bind:value="$t('consent.back')">
              <input type="button" class="dialog-input" v-on:click="onSubmit" v-bind:value="$t('consent.submit')">
            </td>
          </tr>

        </table>

      </td>
      <td  style="width:5%"></td>
    </tr>
    <tr>
      <td id="main-table-row3" colspan="3" > 
      </td>
    </tr>
  </table>

</div>

</template>

<script>

const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
import messageBox from './../common/message-box'
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'consent',
  components: { },
  data() {
      return {
          consents: [],
          consentLength:0,
          //isLoading:false,
          isProcessing:false,
          digitalSignature:""
      }
  },
  methods: {
    load()
    {
      try
      {
        SUPPORT.hideServiceMenus();

        //let menuLogoff = document.getElementById('menuLogoff');
        //let menuSignon = document.getElementById('menuSignon');
        let menuMember = document.getElementById('menuMember');
        //let menuMedicalHistory = document.getElementById('menuMedicalHistory');
        /* let menuCOVID19Questionnaire = document.getElementById('menuCOVID19Questionnaire');
        let menuMedicalTests = document.getElementById('menuMedicalTests');
        let menuOptionalConsents = document.getElementById('menuOptionalConsents'); */
        
        document.getElementById('menuLogoff').classList.remove('is-hidden');
        menuMember.innerHTML = '<span v-on:click="toggleMenus" style="white-space:pre">Hi ' + window.firstName + '</span>'
        //menuSignon.classList.add('is-hidden');
        //document.getElementById('menuMedicalHistory').classList.add('is-hidden');
        //menuCOVID19Questionnaire.classList.add('is-hidden');
        //menuMedicalTests.classList.add('is-hidden');
        //menuOptionalConsents.classList.add('is-hidden');
        
        API.readConsent(window.sessionKey, this.$i18n.locale, 1 /*REQUIRED*/)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.isProcessing = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          { 
            this.consents = response.data.consents;
            this.consentLength = response.data.length;
          }
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
      }
      catch(e)
      {
        this.$generalMessage( messageBox, e );
      }
    },
    getIndex(list, id) {
      return list.findIndex((e) => e.consentTemplateItemId == id)
    },
    validateConsents()
    {
      
      var i ;
      var initials = this.consents[0].consentInitials.toUpperCase();
      for(i = 0; i < this.consentLength; i++)
      {
        if(this.consents[i].consentGiven == true)
        {
          
          if(this.consents[i].consentInitials.length >= 2)
          {
            if(initials != this.consents[i].consentInitials.toUpperCase())
            {
              // Initials do not match in all sections
              this.$generalMessage(messageBox, this.$t("consent.errorNoMatch"), this.addEvents);
              return false;
            }
          }
          else
          {
            // "Invalid Initials."
            this.$generalMessage(messageBox, this.$t("consent.invalidInitials"), this.addEvents);
            return false;
          }
        }
        else
        {
          // Consent not given to one or more sections.
          this.$generalMessage(messageBox, this.$t("consent.consentNotGiven"), this.addEvents);
          return false;
        }
      }

      if(this.digitalSignature == "")
      {
        // You must sign your full name to continue.
        this.$generalMessage(messageBox, this.$t("consent.mustSign"), this.addEvents);
        return false;
      }

      return true;
    },
    goBack()
    {
      SUPPORT.clearSession();
      this.$router.push( { path: "/" } );
      this.isProcessing = false;
    },
    addEvents()
    {
      // RE-ADD EVENT HANDLER FOR ENTER KEY
      document.onkeyup = null;
      document.onkeyup = this.onEnterClicked;
    },
    onSuccess()
    {
      this.$router.push( { path: "/"} );
    },
    onSubmit()
    {
      if(this.isProcessing == true)
      {
        // ELIMINATE DUPLICATE CLICKS OR ENTER KEY STROKES
        return;
      }
      this.isProcessing = true;

      if(!this.validateConsents() != "")
      {
         this.isProcessing = false;
        return;
      }
      
      // SUBMIT
      var i;
      var consentStr = "";
      for(i = 0; i < this.consentLength; i++)
      {
        consentStr = consentStr + this.consents[i].consentTemplateItemId + "~" +
                                  this.digitalSignature + "~" +
                                  this.consents[i].title + "~" +
                                  this.consents[i].statement + "~" +
                                  this.consents[i].consentInitials + "~" +
                                  this.consents[i].consentGiven ;
        
        if(i < this.consentLength - 1)
        {
          consentStr = consentStr + "|";
        }
      }
      
      API.createConsent(window.sessionKey, consentStr, this.$i18n.locale)
      .then(response => {          
        if(response.data.hasError == false)
        {
          // Your consents have been successfully recorded.
          this.$generalMessage(messageBox, this.$t("consent.success"), this.addEvents);
          
          if(response.data.passwordChangeRequired)
          {
            // REDIRECT TO CHANGE PASSWORD
            this.$router.push( { path: "/members/change-password"} );
          }
          else
          {
            // REDIRECT TO THE MEMBER HOME PAGE
           // this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
            {
              this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 2) // FIT FOR DUTY
            {
              this.$router.push( { path: "/members/daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
            {
              this.$router.push( { path: "/members/dashboard"} );
            }
          }
        } 
        else 
        { 
          // FAILED 
          this.$generalMessage(messageBox, response.data.errorMessage, this.addEvents);
          if(response.data.errorId == "4000")
          {
            SUPPORT.clearSession();
            this.$router.push( { path: "/"} );
            this.isProcessing = false;
            return;
          }
          this.isProcessing = false;
        }
      })
      .catch(e => {
        this.$generalMessage(messageBox, e, this.addEvents);
      });  
 
      // ALLOW CLICKS AGAIN
      this.isProcessing = false;
    }
  },
  mounted () {
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);
    
    this.load();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:32px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:95%;
    padding-left: 5%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-consent
  {
    height:55px;
    background-color:#4682B4;
    color:white;
    /* font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold; */
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:0px;
  }
  .dialog-section
  {
    color:white;
    background-color:#343F68;
    padding:15px;
  }
  .dialog-section-title
  {
    font-family:'Lato';
    font-size: 14pt;
    font-style:normal;
    font-weight:600;
    color:white;
    background-color:#343F68;
  }
  .dialog-section-data
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    //padding-left:0px;
    //padding-right:20px;
  }
  .dialog-section-commands
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
  }
  #dialog-section-signature
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:25px;
  }
  #dialog-section-signature-disclaimer
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    padding:15px;
    text-align: justify;
  }
  #dialog-consent-title
  {
    vertical-align:bottom;
    text-align: center;
    //padding-left:8px
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Arial Black';
    font-size: 22pt;
    font-weight: 600;
  }
  .border-dots
  {
      border-bottom-style:none;
  }
  .dialog-input-field-buttons
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    padding-right:8px;
    padding-bottom:50px;
  }  
  .dialog-input
  {
    color:white;
    height:35px;
    background-image: linear-gradient(#4682B4,#4682B4); // STRANGE MOBILE INHERITANCE SHIT
    vertical-align: middle !important; 
  }
  #main-table-row3
  {
    height:60px;
  }
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:85px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-consent
  {
    height:40px;
    width:300px;
    background-color:#4682B4;
    color:white;
   /*  font-family:Lato;//'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold; */
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:25px;
    padding-right:25px;
    padding-bottom:0px;
  }
  .dialog-section
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding:25px;
  }
  .dialog-section-title
  {
    font-family:'Lato';
    font-size: 14pt;
    font-style:normal;
    font-weight:600;
    color:white;
    background-color:#343F68;
    text-align:center !important;
  }
  .dialog-section-data
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-left:40px;
    padding-right:40px;
  }
  .dialog-section-commands
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    padding-left:40px;
    padding-right:40px;
  }
  #dialog-section-signature
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    padding-left:25px;
    padding-right:25px;
    padding-bottom:20px;
  }
  #dialog-section-signature-disclaimer
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    padding:25px;
    text-align: justify;
  }
  .border-dots
  {  
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
  } 
  #dialog-consent-title
  {
    vertical-align:bottom;
    //padding-left:85px
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Lato';
    font-size: 22pt;
    font-weight: 600;
  }
  .dialog-input-field-buttons
  {
    height:50px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input
  {
    color:white;
    background-color:#4682B4 ;   
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:250px;
  }
  // END SIGNON DIALOG STYLES
}
</style>